import classNames from "classnames";
import React from "react";
import { Controller } from "react-hook-form";
import Campos from "../Campos";
import ShowOnSeccionWrapper from "../ShowOnSeccionWrapper";

/**
 * @param {import('components/DynamicForm/typedefs').Seccion} props
 * @returns
 */
const Seccion = (props) => {
  return (
    <React.Fragment>
      <div className='row'>
        {(props.nombre || props.img) && (
          <div
            className={classNames("col-12 dynamic__form__seccion my-2", {
              "ml-md-5": props.nivel === 1,
            })}>
            <div className='d-flex flex-row flex-wrap'>
              {props.img && (
                <img src={props.img} alt='' className='img-fluid dynamic__form__seccion__img' />
              )}
              {props.nombre && (
                <h2 className='align-self-center dynamic__form__seccion__title'>{props?.nombre}</h2>
              )}
              {props?.copiaSeccion && (
                <React.Fragment>
                  <div className='d-flex ml-2'>
                    <div className='align-self-center' style={{ width: "20px" }}>
                      <Controller
                        name={props.codigoCore}
                        defaultValue={false}
                        render={({ value, onChange }) => (
                          <input
                            type='checkbox'
                            className='chek-terminos my-auto mr-2 cpointer'
                            name={props.codigoCore}
                            id={props.codigoCore}
                            checked={value}
                            style={{ height: "20px", width: "20px" }}
                            onChange={(evt) => {
                              onChange(evt.target.checked);
                              props.copiarSeccionJs && props.copiarSeccionJs(evt);
                            }}
                          />
                        )}
                      />
                    </div>
                    <label
                      className='align-self-center cpointer ml-md-2 ml-1'
                      style={{ fontSize: "1.5rem" }}
                      htmlFor={props.codigoCore}>
                      {props?.copiaSeccionLabel}
                    </label>
                  </div>
                </React.Fragment>
              )}
            </div>
          </div>
        )}
      </div>
      {props.nivel === 1 && (
        <div className='row justify-content-center'>
          <div className='col-12'>
            <div className='row justify-content-center'>
              <div className='col-md-11 col-lg-10'>
                <div className='row justify-content-between'>
                  <Campos campos={props.campos} />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {props.nivel === 0 && (
        <div className='row justify-content-center'>
          <div className='col-12'>
            <Campos campos={props.campos} />
          </div>
        </div>
      )}

      {props?.secciones.map((/** @type {import('./typedefs').Seccion} */ seccion) => {
        const component = <Seccion {...seccion} key={seccion.id} />;
        if (seccion?.showOn) {
          return (
            <ShowOnSeccionWrapper
              name={seccion.codigoCore}
              showOn={seccion.showOn}
              key={seccion.id}>
              {component}
            </ShowOnSeccionWrapper>
          );
        }
        return component;
      })}
    </React.Fragment>
  );
};

export default Seccion;
